import React from 'react';
import classnames from 'classnames';
import checkCircle from 'assets/check-circle.svg';
import replaceSettingsMsg from 'utils/replace-settings-msg';

const SuccessPage = ({
  title, close, successTitle, successSummary, accessor, user,
}) => (
  <div>
    <div className="text-center font-bold text-gray-primary mb-2">Success</div>
    <div className="text-lg text-center">{successTitle || `${title} updated`}</div>
    <img
      alt="saved"
      className="mx-auto my-8"
      style={{ height: '92px' }}
      src={checkCircle}
    />
    <div className="text-center mb-6">
      {successSummary && (
        replaceSettingsMsg(successSummary, accessor, user).map(({ text, isBold }) => (
          <p className={classnames('inline', { 'font-bold': isBold })}>
            {text}
          </p>
        ))
      )}
    </div>
    <button
      type="button"
      className="btn w-full bg-gray-primary border-gray-primary flex items-center justify-center"
      onClick={close}
    >
      <i className="fas fa-chevron-left mr-3" />
      <div>Back To Settings</div>
    </button>
  </div>
);


export default SuccessPage;
